import { render } from "./ClientsThingsRequiringAttention.vue?vue&type=template&id=64250625&scoped=true"
import script from "./ClientsThingsRequiringAttention.vue?vue&type=script&lang=js"
export * from "./ClientsThingsRequiringAttention.vue?vue&type=script&lang=js"

import "./ClientsThingsRequiringAttention.vue?vue&type=style&index=0&id=64250625&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3554799265/src/syndesi-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64250625"]])

export default __exports__